import React, { useContext, useEffect, useState } from "react";
import { HiOutlinePlusSm } from "react-icons/hi";
import ParameterContext from "../../context/parameter/parameterContext";
import ShowCoins from "./ShowCoins";
import TradathonContext from "../../context/tradathon/TradathonContext";
import { formatPrice } from "../../helpers/format";
import { IoWallet } from "react-icons/io5";
import NumberFormat from "react-number-format";
import UserAlert from "../../components/Modals/UserAlert";
import FakeShowCoins from "./FakeShowCoins";
import cryptoContext from "../../context/crypto/cryptoContext";
import Countdown from "react-countdown";
import _ from "lodash";
import { BiInfoCircle, BiLock } from "react-icons/bi";
import Info from "../../components/Info";
import { BsChevronDown } from "react-icons/bs";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";

import BreadCrumbs from "../../components/BreadCrumbs";
const TradathonAddCoins = ({ history, location }) => {
  const rmid = location.search ? location.search.split("=")[1] : null;
  const rid = location.search ? location.search.split("=")[2] : null;
  const { setVtButton, vtButton, toggleUserAlertModal, userAlertModal } =
    useContext(ParameterContext);
  const { livePriceData, exchangeRate, currencySymbol } =
    useContext(cryptoContext);
  const {
    getCoins,
    activeRoom,
    coins,
    getCoinsInCurrentContest,
    tradathon_invAmount,
    tradathon_currentAmount,
    tradathon_netPL,
    tradathonLoading,

    tradathon_setTotalInvAmount,
    tradathon_setTotalCurrentAmount,
    tradathon_setTotalNetPL,
  } = useContext(TradathonContext);

  const [openDropdown, setOpenDropdown] = useState(false);
  useEffect(() => {
    setVtButton("position");
    if (!activeRoom) {
      history.push("/tradathon");
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    // getAmountInWallet();

    if (
      ((activeRoom && activeRoom.isPaid) ||
        (activeRoom && activeRoom.room.rstatus === 1 && !activeRoom.isPaid)) &&
      !location.pathname.split("/").includes("roommember")
    ) {
      history.push(
        `/tradathon/room/result?rmid=${activeRoom._id}&rid=${activeRoom.rid}`
      );
    }

    //   tradathon_setTotalCurrentAmount(0)
    //   tradathon_setTotalInvAmount(0)
    // tradathon_setTotalNetPL(0)
    //eslint-disable-next-line
  }, [activeRoom]);
  useEffect(() => {
    if (
      (activeRoom && activeRoom.room.rstatus === 0) ||
      (activeRoom &&
        (activeRoom.room.rstatus === 1 || activeRoom.room.rstatus === 2) &&
        vtButton === "position")
    ) {
      getCoins(rmid.split("&")[0]);
    }

    if (
      activeRoom &&
      activeRoom.room.rstatus !== 0 &&
      (vtButton === "openOrder" || vtButton === "history")
    ) {
      getCoinsInCurrentContest(rmid.split("&")[0], rid);
    }

    // activeRoom&&getCoins(activeRoom)

    //eslint-disable-next-line
  }, [vtButton]);

  useEffect(() => {
    if (
      vtButton === "position" &&
      activeRoom &&
      (activeRoom.room.rstatus === 1 || activeRoom.room.rstatus === 2) &&
      coins &&
      coins.length > 0
    ) {
      tradathon_setTotalInvAmount(_.sum(coins.map((c) => c.investedAmt)));
    }

    if (
      activeRoom &&
      activeRoom.room.rstatus === 1 &&
      coins &&
      coins.length > 0 &&
      vtButton === "position" &&
      livePriceData
    ) {
      tradathon_setTotalCurrentAmount(
        _.sum(
          coins.map((c) => c.quantity * livePriceData[c.cname] * exchangeRate)
        )
      );
    }
    if (
      activeRoom &&
      activeRoom.room.rstatus === 2 &&
      coins &&
      coins.length > 0 &&
      vtButton === "position" &&
      livePriceData
    ) {
      tradathon_setTotalCurrentAmount(activeRoom.currentAmount);
    }
    if (
      activeRoom &&
      activeRoom.room.rstatus === 0 &&
      coins &&
      coins.length > 0 &&
      vtButton === "position" &&
      livePriceData
    ) {
      tradathon_setTotalInvAmount(_.sum(coins.map((c) => c.cstAmount)));
    }

    if (coins && coins.length === 0 && vtButton === "position") {
      tradathon_setTotalInvAmount(0);
      tradathon_setTotalCurrentAmount(0);
      tradathon_setTotalNetPL(0);
    }
    //eslint-disable-next-line
  }, [coins, livePriceData, vtButton, activeRoom]);

  useEffect(() => {
    if (
      activeRoom &&
      (activeRoom.room.rstatus === 1 || activeRoom.room.rstatus === 2) &&
      tradathon_invAmount &&
      tradathon_currentAmount
    ) {
      tradathon_setTotalNetPL(tradathon_currentAmount - tradathon_invAmount);
    }

    //eslint-disable-next-line
  }, [tradathon_invAmount, tradathon_currentAmount]);

  let routes = [];
  if (activeRoom && activeRoom.room) {
    routes = [
      { path: "/tradathon", name: "Tradathon" },

      {
        path: "/",
        name:
          activeRoom?.room?.rstatus === 2
            ? `Completed Contest (${activeRoom.room.rname})`
            : activeRoom?.room?.rstatus === 1
            ? `Live Contest (${activeRoom.room.rname})`
            : `Upcoming Contest (${activeRoom.room.rname})`,
      },
    ];
  }
  const renderer = ({ completed, formatted }) => {
    let { days, hours, minutes, seconds } = formatted;
    let bool = false;
    if (days === "00" && hours === "00" && minutes === "00") {
      bool = true;
    }
    if (completed) {
      history.push("/tradathon");
      toast.success(`${activeRoom.room.rname} Room is Live Now !`, {
        position: "top-right",
        autoClose: 16000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // window.location.reload()
      // getContests("live")
      // Render a completed state
      return <span>Contest Started</span>;
    } else {
      // Render a countdown
      return (
        <div className="timerContainer">
          {activeRoom.room.rstatus === 0 ? (
            <p style={{ margin: "5px 0" }}>Starts In</p>
          ) : activeRoom.room.rstatus === 1 ? (
            <p style={{ margin: "5px 0" }}>Ends In</p>
          ) : (
            <></>
          )}
          <p className="timer" style={{ fontSize: "12px", padding: "2px" }}>
            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : activeRoom.room.rstatus === 1 && "#45AA43",
                  margin: "0 0 0 10px",
                }}
              >
                {days}{" "}
              </span>
              <span className="timeLabel">days</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : activeRoom.room.rstatus === 1 && "#45AA43",
                  margin: "0 0 0 10px",
                }}
              >
                {hours}
              </span>
              <span className="timeLabel">hours</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : activeRoom.room.rstatus === 1 && "#45AA43",
                  margin: "0 0 0 10px",
                }}
              >
                {minutes}
              </span>
              <span className="timeLabel">minutes</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : activeRoom.room.rstatus === 1 && "#45AA43",
                  margin: "0 0 0 10px",
                }}
              >
                {seconds}
              </span>
              <span className="timeLabel">seconds</span>
            </span>
          </p>
        </div>
      );
    }
  };

  return activeRoom ? (
    <div className="Vtrading">
      <div className="Vtrading__container" style={{ marginTop: 0 }}>
        {/* <Title title={`${activeRoom?.room?.rstatus === 2
            ? `(${activeRoom.room.rname}) Completed Contest `
            : activeRoom?.room?.rstatus === 1
            ? `(${activeRoom.room.rname}) Live Contest `
            : `(${activeRoom.room.rname}) Upcoming Contest`} -CoinStorey`}/> */}

        {!location.pathname.split("/").includes("room") && (
          <BreadCrumbs routes={routes} />
        )}
        {userAlertModal && <UserAlert />}
        <center>
          {activeRoom && activeRoom.room.rstatus === 0 ? (
            <Countdown date={activeRoom.room.startTime} renderer={renderer} />
          ) : activeRoom.room.rstatus === 1 ? (
            <Countdown date={activeRoom.room.endTime} renderer={renderer} />
          ) : (
            <></>
          )}
        </center>

        {activeRoom.room.rstatus === 1 && !activeRoom.isPaid ? <Info /> : <></>}
        <div className="Vtrading__section__container">
          <div className="Vtrading__section1">
            {/* <TriggerLive/> */}
            <h3>Statistics</h3>
            <div className="horizontal__line"></div>
            <div className="statistics__container">
              {tradathonLoading || !livePriceData ? (
                <div className="skeleton text" style={{ width: "250px" }} />
              ) : (
                <p>
                  Invested :
                  {tradathon_invAmount ? (
                    <NumberFormat
                      value={formatPrice(tradathon_invAmount / exchangeRate)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySymbol}
                    />
                  ) : (
                    "0"
                  )}
                </p>
              )}
              {tradathonLoading || !livePriceData ? (
                <div className="skeleton text" style={{ width: "250px" }} />
              ) : (
                <p>
                  Net P&L :
                  {activeRoom?.room.rstatus === 0 ? (
                    "NA"
                  ) : tradathon_netPL ? (
                    <NumberFormat
                      value={formatPrice(tradathon_netPL / exchangeRate)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={
                        tradathon_netPL > 0
                          ? `+${currencySymbol}`
                          : currencySymbol
                      }
                    />
                  ) : (
                    0
                  )}
                  (
                  {activeRoom?.room.rstatus === 0 ? (
                    "NA"
                  ) : tradathon_netPL && tradathon_invAmount ? (
                    <span
                      style={{
                        color:
                          tradathon_netPL < 0
                            ? "rgba(233, 56, 72, 1)"
                            : "rgba(69, 170, 67, 1)",
                      }}
                    >
                      <NumberFormat
                        value={
                          tradathon_netPL &&
                          tradathon_invAmount &&
                          formatPrice(
                            (Math.abs(tradathon_netPL) / tradathon_invAmount) *
                              100
                          )
                        }
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={
                          (tradathon_netPL / tradathon_invAmount) * 100 < 0
                            ? "-"
                            : "+"
                        }
                        suffix={"%"}
                      />
                    </span>
                  ) : (
                    0
                  )}
                  )
                </p>
              )}
              {tradathonLoading || !livePriceData ? (
                <div className="skeleton text" style={{ width: "250px" }} />
              ) : (
                <p>
                  Current :
                  {activeRoom?.room.rstatus === 0 ? (
                    "NA"
                  ) : tradathon_currentAmount ? (
                    <NumberFormat
                      value={formatPrice(
                        tradathon_currentAmount / exchangeRate
                      )}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySymbol}
                    />
                  ) : (
                    0
                  )}
                </p>
              )}
            </div>
          </div>
          <div className="Vtrading__section3">
            <div>
              <h2 style={{ display: "flex", alignItems: "flex-end" }}>
                <IoWallet size={25} style={{ marginRight: "15px" }} />
                <span>Portfolio Value</span>
              </h2>
              {tradathonLoading || !livePriceData ? (
                <div
                  className="skeleton text"
                  style={{ width: "250px", height: "40px", marginTop: "20px" }}
                />
              ) : (
                <h1>
                  {activeRoom?.room.rstatus === 0
                    ? `${formatPrice(100000 / exchangeRate)}CST`
                    : activeRoom.room.rstatus === 2 && activeRoom.anotherRM
                    ? formatPrice(
                        activeRoom.anotherRM?.balance +
                          (tradathon_currentAmount
                            ? tradathon_currentAmount / exchangeRate
                            : 0)
                      )
                    : formatPrice(
                        activeRoom.balance +
                          (tradathon_currentAmount
                            ? tradathon_currentAmount / exchangeRate
                            : 0)
                      )}
                  {activeRoom?.room.rstatus === 0 ? "" : "CST"}
                </h1>
              )}
            </div>
          </div>

          <div className="Vtrading__section2">
            <h2>Available Balance</h2>
            {tradathonLoading || !livePriceData ? (
              <div
                className="skeleton text"
                style={{ width: "250px", height: "40px", marginTop: "20px" }}
              />
            ) : (
              <h1>
                {activeRoom.room.rstatus === 2 && activeRoom.anotherRM
                  ? activeRoom.anotherRM?.balance - activeRoom.lockAmount === 0
                    ? 0
                    : formatPrice(
                        (activeRoom.anotherRM?.balance -
                          activeRoom.lockAmount) /
                          exchangeRate
                      )
                  : formatPrice(
                      (activeRoom.balance - activeRoom.lockAmount) /
                        exchangeRate
                    )}
                CST
              </h1>
            )}

            {tradathonLoading || !livePriceData ? (
              <div
                className="skeleton text"
                style={{ width: "250px", height: "20px" }}
              />
            ) : (
              <p>
                {activeRoom.lockAmount <= 0 ? (
                  <br />
                ) : (
                  `Lock Amount:${formatPrice(
                    activeRoom.lockAmount / exchangeRate
                  )}`
                )}
              </p>
            )}
          </div>
        </div>

        {activeRoom.room.rstatus === 1 && !activeRoom.isPaid ? (
          <></>
        ) : (
          <div
            className="VtradingScreen2__investment__page__container"
            style={{
              gridTemplateColumns: "1fr 1fr",
              margin: "20px 0",
            }}
          >
            <button
              className="TradathonRoom__button"
              style={{
                margin: 0,
                width: "150px",
                visibility:
                  activeRoom.room.rstatus !== 2 ? "visible" : "hidden",
              }}
              onClick={() => history.push("/tradathon/screen")}
            >
              + <span>Add More Coins</span>
            </button>

            <div
              className="Vtrading__buttons_group"
              style={{
                justifyContent: "flex-end",
                marginLeft: "120px",
                gap: "15px",
                visibility:
                  activeRoom && activeRoom.room.rstatus !== 0
                    ? "visible"
                    : "hidden",
              }}
            >
              <button
                className="Vtrading__button"
                onClick={() => setVtButton("position")}
                style={{
                  background: vtButton === "position" ? "#e8bd6e" : "#fff",
                  color: vtButton === "position" ? "#fff" : "#000",
                }}
              >
                Position
              </button>
              <button
                className="Vtrading__button"
                style={{
                  background: vtButton === "history" ? "#e8bd6e" : "#fff",
                  color: vtButton === "history" ? "#fff" : "#000",
                }}
                onClick={() => setVtButton("history")}
              >
                History
              </button>
              <button
                className="Vtrading__button"
                style={{
                  background: vtButton === "openOrder" ? "#e8bd6e" : "#fff",
                  color: vtButton === "openOrder" ? "#fff" : "#000",
                }}
                onClick={() => setVtButton("openOrder")}
              >
                Open order
              </button>
            </div>
            <div
              className="Mobile__vtrading-dropdown"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="TradathonRoom__button-Mobile"
                style={{
                  margin: 0,
                  position: "relative",
                }}
                onClick={() => setOpenDropdown(!openDropdown)}
              >
                <BsChevronDown size={14} />
                {openDropdown && (
                  <div
                    className="Appbar__profile__transparent"
                    style={{ display: "block" }}
                  >
                    {/* <div className="Appbar__profile__dropdown__triangle"></div> */}
                    <div
                      className="Appbar__profile__dropdown"
                      style={{ height: "120px" }}
                    >
                      <ul
                        style={{
                          listStyleType: "none",
                          paddingLeft: 0,
                          alignItems: "flexStart",
                        }}
                      >
                        <li
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setOpenDropdown(false);
                            setVtButton("position");
                          }}
                        >
                          Position
                        </li>
                        <li
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setOpenDropdown(false);
                            setVtButton("history");
                          }}
                        >
                          History
                        </li>{" "}
                        <li
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setOpenDropdown(false);
                            setVtButton("openOrder");
                          }}
                        >
                          Open Order
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </button>
            </div>
          </div>
        )}

        {tradathonLoading || !livePriceData ? (
          <FakeShowCoins />
        ) : coins ? (
          coins.length > 0 ? (
            <ShowCoins />
          ) : activeRoom &&
            activeRoom.room &&
            activeRoom.room.rstatus === 1 &&
            !activeRoom.isPaid ? (
            <div
              className="Vtrading__investment__container"
              style={{ marginTop: "50px" }}
            >
              <div className="Vtrading__investment__content__container">
                <div
                  className="Vtrading__investment__icon__container"
                  style={{ cursor: "pointer" }}
                >
                  <BiLock size={60} />
                </div>
                <p>
                  Your Portfolio has been locked <br />
                  as you do not paid for contest
                </p>
              </div>
            </div>
          ) : activeRoom.room.rstatus === 2 ? (
            <div
              className="Vtrading__investment__container"
              style={{ marginTop: "50px" }}
            >
              <div className="Vtrading__investment__content__container">
                <div
                  className="Vtrading__investment__icon__container"
                  onClick={() => history.push("/tradathon/screen")}
                  style={{ cursor: "pointer" }}
                >
                  <BiLock size={60} />
                </div>
                <p>
                  Contest Completed
                  <br />
                  You have no orders
                </p>
              </div>
            </div>
          ) : (
            <div
              className="Vtrading__investment__container"
              style={{ marginTop: "50px" }}
            >
              <div className="Vtrading__investment__content__container">
                <div
                  className="Vtrading__investment__icon__container"
                  onClick={() => history.push("/tradathon/screen")}
                  style={{ cursor: "pointer" }}
                >
                  <HiOutlinePlusSm size={60} />
                </div>
                <p>
                  No Investment Done Buy <br />
                  your Coins Now
                </p>
              </div>
            </div>
          )
        ) : (
          <></>
        )}
        {activeRoom && activeRoom.room.rstatus === 0 && !activeRoom.isPaid && (
          <center>
            <ReactTooltip place="top" effect="float" multiline={true} />
            <button
              className="TradathonRoom__join__button"
              style={{
                background: "rgba(69, 170, 67, 1)",
                borderRadius: "5px",
                whiteSpace: "nowrap",

                fontSize: "18px",
                marginTop: "15px",
                // cursor:coins&&coins.length===0?"not-allowed":"pointer",
                display: "flex",
                alignItems: "center",
              }}
              // disabled={coins&&coins.length===0}
              // onClick={() => {payForTradathon()
              //   history.push(`/tradathon/room/result?rmid=${activeRoom._id}&rid=${activeRoom.rid}`)
              // }}
              onClick={() => {
                // activeRoom.room.EntryFees<=userData.walletData.totalAmt&&!activeRoom.isPaid?payForTradathon():
                coins && coins.length > 0
                  ? toggleUserAlertModal()
                  : toast.error(
                      "You cannot lock and pay until you have atleast a coin in your portfolio",
                      { autoClose: 6000 }
                    );
              }}
            >
              LOCK & PAY
              <span>
                <BiInfoCircle
                  size={26}
                  data-tip="You cannot lock and pay until you have atleast a coin in your portfolio"
                />
              </span>
            </button>
          </center>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default TradathonAddCoins;
